<ia-icons
  name="default:file_lines"
  class="tw-hidden tw-h-10 md:tw-block"
  color="currentColor"
  [ngClass]="{
    'tw-text-eerie-black': !hasError,
    'tw-text-red-500': hasError,
  }"
/>
<div class="tw-flex-col tw-justify-start tw-pl-3 tw-pr-10 sm:tw-flex sm:tw-w-3/5">
  <div class="tw-flex tw-items-center">
    <ia-icons
      name="default:file_lines"
      class="tw-block tw-h-10 md:tw-hidden"
      color="currentColor"
      [ngClass]="{
        'tw-text-eerie-black': !hasError,
        'tw-text-red-500': hasError,
      }"
    />
    @if (documentAttachmentGroup?.label) {
      <span
        class="tw-ml-5 tw-font-sans tw-text-base tw-uppercase tw-leading-5 sm:tw-ml-0"
        [ngClass]="{
          'tw-text-eerie-black': !hasError,
          'tw-text-red-500': hasError,
        }"
      >
        {{ documentAttachmentGroup?.label }}
      </span>
    }
  </div>
  @if (documentAttachmentGroup?.description) {
    <p
      class="tw-mt-2.5 tw-font-sans tw-text-sm tw-font-semibold"
      [ngClass]="{
        'tw-text-gray': !hasError,
        'tw-text-red-500': hasError,
      }"
    >
      {{ documentAttachmentGroup?.description }}
    </p>
  }
  @if (documentAttachmentGroup?.furtherDescription) {
    <p
      class="tw-mt-3 tw-text-sm"
      [ngClass]="{
        'tw-text-gray': !hasError,
        'tw-text-red-500': hasError,
      }"
    >
      {{ documentAttachmentGroup?.furtherDescription }}
    </p>
  }
</div>

<div
  class="tw-flex tw-flex-col tw-space-y-10 tw-border-l tw-border-geyser tw-pl-6 tw-pt-2 sm:tw-w-2/5"
>
  @if (typeDocuments.length) {
    <form [formGroup]="documentForm" class="tw-flex tw-flex-col tw-items-start tw-space-y-2">
      @if (
        documentAttachmentGroup?.isList && selfCareTypeDocuments && selfCareTypeDocuments.length > 1
      ) {
        <ia-listbox2
          formControlName="type"
          [overlayOverrides]="listBoxOverlayConfig"
          class="tw-mt-2.5 tw-w-75 tw-max-w-full"
          triggerId="document-type"
          triggerAriaLabel="document type"
        >
          <div *iaListbox2Placeholder>
            {{
              'screens.deceasedMoreInformation.information.documents.documentTypePlaceholder'
                | translate
            }}
          </div>

          @for (option of typeDocuments; track option.value) {
            <ia-listbox2-option [value]="option.value">
              {{ option.label }}
            </ia-listbox2-option>
          }
        </ia-listbox2>
      }
      <button
        (click)="openDocumentDialog()"
        [disabled]="documentForm.invalid"
        iaButton
        id="btn-deceased-information-next"
        data-test-id="btn-deceased-information-next"
        type="button"
        variant="secondary"
      >
        {{ 'screens.deceasedMoreInformation.buttons.buttonAddDocument.label' | translate }}
      </button>
    </form>
  }

  @for (group of documents; track group) {
    @if (group.documents.length) {
      <div class="tw-flex tw-space-x-2.5">
        <ia-icons
          name="default:circle_check_filled_part"
          class="tw-h-10"
          color="currentColor"
          [ngClass]="{
            'tw-text-eerie-black': !hasError,
            'tw-text-red-500': hasError,
          }"
        />
        <div class="tw-flex tw-flex-col">
          <span class="tw-font-bold">{{ group.type.label }}</span>
          <span class="tw-text-emerald">
            @if (group.documents.length < 2) {
              {{ 'screens.deceasedMoreInformation.information.documents.downloaded' | translate }}
            }
            @if (group.documents.length >= 2) {
              {{
                'screens.deceasedMoreInformation.information.documents.downloadedMulti' | translate
              }}
            }
          </span>
          <button
            data-test-id="btn-open-document-dialog"
            (click)="openDocumentDialog(group.type)"
            class="tw-cursor-pointer tw-text-gray tw-underline"
          >
            @if (group.documents.length < 2) {
              {{ 'screens.deceasedMoreInformation.information.documents.visit' | translate }}
            }
            @if (group.documents.length >= 2) {
              {{ 'screens.deceasedMoreInformation.information.documents.visitMulti' | translate }}
            }
          </button>
        </div>
      </div>
    }
  }
</div>
